import { Controller } from "@hotwired/stimulus"
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

// Connects to data-controller="download"
export default class extends Controller {
  static values = {
    name: String
  }

  connect() {
  }

  async saveFile(event) {
    event.target.classList.add('loading');

    await Filesystem.deleteFile({
      directory: Directory.Data,
      path: this.nameValue
    })

    await Filesystem.downloadFile({
      method: 'GET',
      url: document.querySelector('audio').src,
      directory: Directory.Data,
      path: this.nameValue
    });

    event.target.classList.remove('loading');

    alert('File saved to you device!');
  }
}
